import React, { useState, useEffect } from 'react';
import { linkService } from '../services/linkService';
import LinkForm from './LinkForm';
import './LinksList.css';

const LinksList = () => {
  const [links, setLinks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [showForm, setShowForm] = useState(false);
  const [editingLink, setEditingLink] = useState(null);

  useEffect(() => {
    loadLinks();
  }, []);

  const loadLinks = async () => {
    try {
      setLoading(true);
      const response = await linkService.getAll();
      if (response.success) {
        setLinks(response.data);
      } else {
        setError(response.message || 'Không thể tải danh sách links');
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Lỗi khi tải danh sách links');
    } finally {
      setLoading(false);
    }
  };

  const handleCreate = () => {
    setEditingLink(null);
    setShowForm(true);
  };

  const handleEdit = (link) => {
    setEditingLink(link);
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Bạn có chắc chắn muốn xóa link này?')) {
      return;
    }

    try {
      const response = await linkService.delete(id);
      if (response.success) {
        loadLinks();
      } else {
        alert(response.message || 'Xóa link thất bại');
      }
    } catch (err) {
      alert(err.response?.data?.message || 'Lỗi khi xóa link');
    }
  };

  const handleFormClose = () => {
    setShowForm(false);
    setEditingLink(null);
    loadLinks();
  };

  if (loading) {
    return <div className="loading">Đang tải...</div>;
  }

  return (
    <div className="links-list">
      <div className="links-header">
        <h2>Danh sách Links</h2>
        <button onClick={handleCreate} className="create-button">
          + Tạo link mới
        </button>
      </div>

      {error && <div className="error-message">{error}</div>}

      {showForm && (
        <LinkForm
          link={editingLink}
          onClose={handleFormClose}
          onSuccess={handleFormClose}
        />
      )}

      {links.length === 0 ? (
        <div className="empty-state">Chưa có link nào. Hãy tạo link mới!</div>
      ) : (
        <table className="links-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Link gốc</th>
              <th>Link redirect</th>
              <th>Ngày tạo</th>
              <th>Thao tác</th>
            </tr>
          </thead>
          <tbody>
            {links.map((link) => (
              <tr key={link.id}>
                <td>{link.id}</td>
                <td className="original-url">
                  <a
                    href={link.originalUrl.startsWith('http://') || link.originalUrl.startsWith('https://') 
                      ? link.originalUrl 
                      : `http://${link.originalUrl}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={(e) => e.stopPropagation()}
                  >
                    {link.originalUrl}
                  </a>
                </td>
                <td>
                  <div className="redirect-urls">
                    {link.redirectUrls.map((url, index) => (
                      <a
                        key={index}
                        href={url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="redirect-url"
                        onClick={(e) => e.stopPropagation()}
                      >
                        {url}
                      </a>
                    ))}
                  </div>
                </td>
                <td>{new Date(link.createdAt).toLocaleDateString('vi-VN')}</td>
                <td>
                  <div className="actions">
                    <button
                      onClick={() => handleEdit(link)}
                      className="edit-button"
                    >
                      Sửa
                    </button>
                    <button
                      onClick={() => handleDelete(link.id)}
                      className="delete-button"
                    >
                      Xóa
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default LinksList;

